var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-detail-container" },
    [
      _c("p", { staticClass: "tips" }, [
        _vm._v(_vm._s(_vm.$t("tips.cash_out_setting_detail"))),
      ]),
      _c("div", { staticClass: "flex-justify-between-align-center mt-24" }, [
        _c("div", [
          _c("span", { staticClass: "setting-detail-label" }, [
            _vm._v(_vm._s(_vm.$t("system.withdraw_type")) + ":"),
          ]),
          _c("span", { staticClass: "color-488CE8" }, [
            _vm._v(
              " " +
                _vm._s(_vm.withdrawTypeMapLabel(_vm.withdrawInfo.withdraw_type))
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "setting-detail-opeartion" },
          [
            _c(
              "el-button",
              {
                staticStyle: { margin: "0", "margin-left": "20px" },
                attrs: {
                  type: "info",
                  plain: "",
                  "class-name": "icon-function",
                  "icon-class": "operation-edit",
                },
                on: { click: _vm.edit },
              },
              [_vm._v(_vm._s(_vm.$t("components.edit")))]
            ),
          ],
          1
        ),
      ]),
      _vm.withdrawInfo.withdraw_type === _vm.WITHDRAW_TYPE["automatic"]
        ? [
            _c(
              "div",
              { staticClass: "flex-justify-between-align-center mt-24" },
              [
                _c("div", [
                  _c("span", { staticClass: "setting-detail-label" }, [
                    _vm._v(_vm._s(_vm.$t("merchant.withdrawal_account")) + ":"),
                  ]),
                  _c("span", { staticClass: "color-488CE8" }, [
                    _vm._v(
                      _vm._s(
                        _vm.bankInfo.settlement_bank +
                          "(" +
                          _vm.bankInfo.settlement_bank_account_num +
                          ")"
                      )
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "flex-justify-between-align-center mt-24" },
              [
                _c("div", [
                  _c("span", { staticClass: "setting-detail-label" }, [
                    _vm._v(_vm._s(_vm.$t("system.auto_withdraw_type")) + ":"),
                  ]),
                  _c("span", { staticClass: "color-488CE8" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.autoWithdrawTypeMapLabel(
                            _vm.withdrawInfo.auto_withdraw_type
                          )
                        )
                    ),
                  ]),
                ]),
              ]
            ),
            _vm.withdrawInfo.auto_withdraw_type ===
            _vm.AUTO_WITHDRAW_TYPE["period"]
              ? [
                  _c(
                    "div",
                    { staticClass: "flex-justify-between-align-center mt-24" },
                    [
                      _c("div", [
                        _c("span", { staticClass: "setting-detail-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("data.withdrawal_period")) + ":"
                          ),
                        ]),
                        _c("span", { staticClass: "color-488CE8" }, [
                          _vm._v(
                            " D+" + _vm._s(_vm.withdrawInfo.auto_withdraw_dates)
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-justify-between-align-center mt-24" },
                    [
                      _c("div", [
                        _c("span", { staticClass: "setting-detail-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("data.next_cash_out_date")) + ":"
                          ),
                        ]),
                        _c("span", { staticClass: "color-488CE8" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.withdrawInfo.auto_withdraw_next_date)
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm.isCurCountryID
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex-justify-between-align-center mt-24",
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              { staticClass: "setting-detail-label" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("data.minimum_cash_out_amount")
                                  ) + ":"
                                ),
                              ]
                            ),
                            _c("span", { staticClass: "color-488CE8" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toDivideWithDot")(
                                      _vm.withdrawInfo.withdraw_threshold
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-size": "10px" } },
                                [
                                  _vm._v(
                                    "( " +
                                      _vm._s(
                                        _vm.$t(
                                          "tips.automatic_withdrawal_amount_limit_1"
                                        )
                                      ) +
                                      _vm._s(
                                        _vm._f("toDivideWithDot")(
                                          _vm.withdrawInfo.withdraw_threshold
                                        )
                                      ) +
                                      _vm._s(
                                        _vm.$t(
                                          "tips.automatic_withdrawal_amount_limit_2"
                                        )
                                      ) +
                                      " )"
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "flex-justify-between-align-center mt-24" },
                    [
                      _c("div", [
                        _c("span", { staticClass: "setting-detail-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.fixed_amount")) + ":"),
                        ]),
                        _c("span", { staticClass: "color-488CE8" }, [
                          _vm._v(_vm._s(_vm.withdrawInfo.auto_withdraw_amount)),
                        ]),
                      ]),
                    ]
                  ),
                ],
          ]
        : _vm._e(),
      _vm.withdraw_fee_status === 1
        ? _c(
            "div",
            { staticClass: "flex-justify-between-align-center mt-24" },
            [
              _c("div", [
                _c("span", { staticClass: "setting-detail-label" }, [
                  _vm._v(_vm._s(_vm.$t("system.handling_fee")) + ":"),
                ]),
                _c("span", { staticClass: "color-488CE8" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("toDivideWithDot")(_vm.withdraw_fee)) +
                      " " +
                      _vm._s(_vm.$t("system.per_transaction"))
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _c("ModifyWithdrawMethodModal", {
        ref: "modifyWithdrawMethodModal",
        on: { changeComponent: _vm.changeComponent, submit: _vm.getInfo },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }